import { PredefinedPricingTierValue } from './predefined-pricing-tier.value';

export class PredefinedPricingTierValueDto {
    label: string;
    minUsers: number;
    maxUsers: number | null;
    prices: Record<string, number>;

    constructor(data: PredefinedPricingTierValue) {
        this.label = data.label;
        this.minUsers = data.minUsers;
        this.maxUsers = data.maxUsers;
        this.prices = data.prices;
    }
}
